import router from "../router"
import routes from "../router/routes"

export const transformDomainRoutes = (domains, locale, activeRoute) => {
  return domains.map(({ node: { slug, domain, image } }) => {
      const name = domain
      const route = routes.projects.path
      const routeParams = { domain: slug, locale }
      const isActiveRoute = router(route, routeParams) === activeRoute

      return ({
          route,
          routeParams,
          name,
          image,
          active: isActiveRoute
      })
    })
}